import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spin } from 'antd';
import { gql, useMutation, useLazyQuery } from '@apollo/client';

import Login from '../../components/Login';
import { updateToken, updateUser } from '../../store/reducers/loginSlice';
import { ME_QUERY } from '../../apollo/queries';
import { createAbility } from '../../utils/ability';

const LoginWrapperContainer = styled.div`
  padding-top: 3rem;
`;
const AppName = styled.h1`
  font-family: 'Righteous';
  text-align: center;
  margin-bottom: 3rem;
`;

const LOGIN_MUTATION = gql`
  mutation Login($username: String!, $password: String!) {
    login(username: $username, password: $password)
  }
`;

const LoginContainer = ({ router }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [errorMsg, setErrorMsg] = useState('');

  const [doLogin, { loading, error, data }] = useMutation(LOGIN_MUTATION);

  const [getUser, { data: userData }] = useLazyQuery(ME_QUERY, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (data) {
      if (data.login) {
        localStorage.setItem('token', data.login);
        dispatch(updateToken({ token: data.login }));
        getUser();
      } else {
        setErrorMsg('Invalid login!!!');
      }
    }
    if (error) {
      setErrorMsg('Something went wrong. Please try after sometime!!!');
    }
  }, [data, error, history, dispatch, getUser]);

  useEffect(() => {
    if (userData && userData.me) {
      const ability = createAbility(userData.me);
      dispatch(updateUser({ user: { ...userData.me, ability } }));
      history.push('/');
    }
  }, [userData, dispatch, history]);

  return (
    <Spin spinning={loading} size="large">
      <LoginWrapperContainer>
        <AppName>MirDocs</AppName>
        <Login
          onLoginBtnClicked={(username, password) => {
            if (username && password) {
              doLogin({ variables: { username, password } });
            }
          }}
          error={errorMsg}
        />
      </LoginWrapperContainer>
    </Spin>
  );
};

export default LoginContainer;
